import { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { ProgressTrack, ProgressInputRange } from '../../Player/styles';

const VastControlBarProgress = ({ player }: { player: HTMLVideoElement }) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  useEffect(() => {
    const onVastTime = (e: CustomEvent) => {
      setCurrentTime(e.detail.currentTime ?? 0);
      setDuration(e.detail.duration ?? 0);
    };
    player.addEventListener('vast.time', onVastTime as EventListener);
    return () => player.removeEventListener('vast.time', onVastTime as EventListener);
  }, [player]);

  return (
    <ProgressTrack id="vast-progress-track" playingAd={true}>
      <ProgressInputRange
        id="vast-seekBar"
        disabled
        playingAd={true}
        type="range"
        step="any"
        max={String(duration)}
        value={currentTime}
      />
      <Progress currentTime={currentTime} duration={duration} />
    </ProgressTrack>
  );
};

const Progress = styled.div<{ currentTime: number; duration: number }>(({ theme, currentTime, duration }) => ({
  borderRadius: '0.5rem',
  zIndex: 20,
  position: 'absolute',
  width: duration > 0 ? `${(currentTime / duration) * 100}%` : '0%',
  maxWidth: '100%',
  height: '100%',
  top: 0,
  left: 0,
  backgroundColor: theme.palette.success[900][0],
  pointerEvents: 'none',
}));

export default VastControlBarProgress;
